import clone from '../../utils/clone';

export default function lastAction(state, action) {
    if(state === undefined) {
        return null;
    }

    return clone(action);
}
